export default __webpack_public_path__ + "static/media/homeTopicMap.2d38ac6a.jpg";